export {default} from './Slider.component';

